import { Alert, CircularProgress, Grid } from '@mui/material'

import Header from '../header'

import classes from './index.styles'

interface ScreenProps {
  loading?: boolean
  error?: string
  /** Header component if it is NOT the default header. If it is, use `headerProps` instead */
  header?: React.ReactNode
  showHeader?: boolean
  /** Props for the default header. Ignored if `header` is provided */
  headerProps?: typeof Header extends React.ComponentType<infer P> ? P : never
  footer?: React.ReactNode
  children: React.ReactNode | React.ReactNode[]
}

/** Shared full-screen card layout on blue background for onboarding routes, including the setup header and loading/error states.
 * Example usage:
 * <OnboardingScreen loading={true} error="Something went wrong">
 *   <MainContent />
 * </OnboardingScreen>
 */
const OnboardingScreen = ({ loading, error, header, showHeader = true, headerProps, footer, children }: ScreenProps) => {
  return (
    <Grid container={true} sx={[classes.containerRoot, classes.onboardingRoot]}>
      <Grid container={true} sx={classes.onboardingContent}>
        {showHeader &&
          (header || <Header showLogo={false} title="Setup" showDownloadAppButton={false} showUserMenu={true} showCompactUserMenu={true} {...headerProps} />)}
        {loading ? (
          <Grid container={true} size={12} sx={[classes.loadingContainer, classes.onboardingLoadingContainer]}>
            <CircularProgress />
          </Grid>
        ) : error ? (
          <Alert severity="error" sx={classes.errorAlert}>
            {error}
          </Alert>
        ) : (
          children
        )}
        {footer}
      </Grid>
    </Grid>
  )
}

export default OnboardingScreen
